import { BranchSettings } from "@/config/constant";
import { __localesModel } from "@/Utils/locales";

const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  model[BranchSettings.Locales] = __localesModel;
  return model;
};

export const models = createObj(BranchSettings);

export const options = {};

export const Fields = [
  {
    label: "Branch settings",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    name: BranchSettings.Locales,
    placeholder: "Enter your Branch Name",
    placeholder2: "About your branch",
    type: "localized",
    value: "",
    xl: "11",
    validationMessage: {
      required: "This field is required"
    }
  },

  {
    label: "Contact settings",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Phone Number",
    name: BranchSettings.ContactPhone,
    placeholder: "Enter your contact Phone number",
    xl: "4",
    type: "phone"
  },
  {
    label: "Whatsapp Number",
    name: BranchSettings.Whatsapp,
    placeholder: "Enter your Whatsapp number",
    xl: "4",
    type: "phone"
  },
  {
    label: "Address",
    name: BranchSettings.Address,
    placeholder: "Enter your Address",
    type: "text",
    value: "",
    xl: "4",
    validationMessage: {
      required: "This field is required"
    }
  },

  {
    label: "Preferences",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Dine In",
    name: BranchSettings.DineIn,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Delivery",
    name: BranchSettings.Delivery,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Car Pickup",
    name: BranchSettings.CarPickup,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Self Pickup",
    name: BranchSettings.SelfPickUp,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    type: "spacer"
  }
];
